//@ts-nocheck
import { Transforms, Node, Editor, Element, Path, Range } from 'slate'
import { ElementWithType } from '../../../../../../../utils/types'
import { normalTextElement } from '../../paragraph/utils'
import { LIST_TYPES, getRootListPath, splitSelectedList } from '../utils'
import { isEqual } from 'lodash'
import { jsx } from 'slate-hyperscript'
import { ReactEditor } from 'slate-react'

export const outdentListItem = (editor, li) => {
  const liPath = li[1]
  const liPathRef = Editor.pathRef(editor, liPath)

  Editor.withoutNormalizing(editor, () => {

    const shouldSplitAtStart = liPath.at(-1) !== 0
    const shouldSplitAtEnd = Editor.hasPath(editor, Path.next(liPath))

    shouldSplitAtStart && Transforms.splitNodes(editor, {
      at: liPathRef.current,
    })

    shouldSplitAtEnd && Transforms.splitNodes(editor, {
      at: Path.next(liPathRef.current),
    })

    Transforms.unwrapNodes(editor, {
      at: Path.parent(liPathRef.current),
      match: (n) => LIST_TYPES.includes(n.type),
    })
  })
}

export const outdentListItemForUpdatedListStructure = (editor, liEntry) => {
  if (liEntry[0]?.type !== 'li') return

  const liPath = liEntry[1]
  const liIndex = liPath.at(-1)

  const parentListEntry = Editor.parent(editor, liPath)

  const parentLiEntry = getParentLi(editor, liPath)
  const nextListEntry = getNextList(editor, liPath)

  if (!parentLiEntry || !parentListEntry) return

  const [parentList, parentListPath] = parentListEntry
  const parentLiPath = parentLiEntry[1]

  let location = [
    [...parentListPath, liIndex + 1],
    [...parentListPath, parentList.children.length - 1]
  ]

  const hasOnlyOneNextSibling = isEqual(location[0], location[1])
  const hasNoNextSibling = liIndex === parentList.children.length - 1


  if (hasOnlyOneNextSibling) {
    location = location[0]
  }
  if (!hasNoNextSibling) {
    Transforms.wrapNodes(editor, jsx('element', { type: parentList['type'] }), {
      // @ts-ignore
      at: location
    })
    const wrappedListRef = Editor.pathRef(editor, Path.next(liPath))

    let entry = liEntry

    if (nextListEntry) {

      entry = nextListEntry
    }

    Transforms.moveNodes(editor, { at: wrappedListRef.current, to: [...entry[1], entry[0].children.length] })

    if (nextListEntry) {


      Transforms.unwrapNodes(editor, { at: wrappedListRef.current })
    }
    wrappedListRef.unref()
  }

  if (parentLiPath) Transforms.moveNodes(editor, { at: liPath, to: Path.next(parentLiPath) })
}

export const indentListItem = (editor, li) => {
  const liItem = li[0]
  const liPath = li[1]
  const liPathLastIndex = liPath.length - 1
  const parent = Node.get(editor, liPath.slice(0, liPathLastIndex)) as any;

  // return null if user try to create new inner list on first li child
  if (liPath[liPathLastIndex] == 0) {
    return null
  }

  const prevSiblingData = (liPath, liPathLastIndex) => {
    const prevSiblingPath = [...liPath.slice(0, liPathLastIndex), liPath[liPathLastIndex] - 1]
    const prevSibling = Node.get(editor, prevSiblingPath) as any;

    if (prevSibling.type === 'ol' || prevSibling.type === 'ul') {
      return { childen: prevSibling.children, path: prevSiblingPath }
    }
    return null
  }

  const nextSiblingData = (liPath, liPathLastIndex, parent) => {
    const doesNextSiblingExist = parent.children.length - 1 > liPath[liPathLastIndex]

    if (!doesNextSiblingExist) {
      return null
    }

    const nextSiblingPath = [...liPath.slice(0, liPathLastIndex), liPath[liPathLastIndex] + 1]

    const nextSibling = Node.get(editor, nextSiblingPath) as any;

    if (nextSibling.type === 'ol' || nextSibling.type === 'ul') {
      return { childen: nextSibling.children, path: nextSiblingPath }
    }
    return null
  }

  const prevSibling: any = prevSiblingData(liPath, liPathLastIndex)
  const nextSibling: any = nextSiblingData(liPath, liPathLastIndex, parent)

  if (prevSibling && nextSibling) {
    const children = [...prevSibling.childen, liItem, ...nextSibling.childen]
    const newNode = { type: parent.type, attrs: {}, children }

    Transforms.removeNodes(editor, { at: nextSibling.path })
    Transforms.removeNodes(editor, { at: liPath })
    Transforms.removeNodes(editor, { at: prevSibling.path })
    Transforms.insertNodes(editor, newNode, { at: prevSibling.path })

    Transforms.select(editor, [...prevSibling.path, prevSibling.childen.length])
    Transforms.collapse(editor, { edge: 'start' })
  } else if (prevSibling) {
    const liNewPath = [...prevSibling.path, prevSibling.childen.length]
    Transforms.removeNodes(editor, { at: liPath })
    Transforms.insertNodes(editor, liItem, { at: liNewPath })

    Transforms.select(editor, liNewPath)
    Transforms.collapse(editor, { edge: 'start' })
  } else if (nextSibling) {
    const liNewPath = [...nextSibling.path, 0]

    Transforms.insertNodes(editor, liItem, { at: liNewPath })
    Transforms.removeNodes(editor, { at: liPath })

    Transforms.select(editor, [
      ...nextSibling.path.slice(0, nextSibling.path.length - 1),
      nextSibling.path[nextSibling.path.length - 1] - 1,
      0,
    ])
    Transforms.collapse(editor, { edge: 'start' })
  } else {
    const newNode = { type: parent.type, attrs: {}, children: [liItem] }
    Transforms.removeNodes(editor, { at: liPath })
    Transforms.insertNodes(editor, newNode, { at: liPath })

    Transforms.select(editor, [...liPath, 0])
    Transforms.collapse(editor, { edge: 'start' })
  }
}

export const indentMultipleListItems = (editor) => {

  const selectedListItems = Array.from(Editor.nodes(editor, {
    match: (n) => {
      return n['type'] === 'li'
    }
  }))

  if (selectedListItems[0][1].at(-1) === 0) return
  const selectedListItemPathRefs = selectedListItems.map(([, path]) => {
    return Editor.pathRef(editor, path)
  })

  for (const liPathRef of selectedListItemPathRefs) {
    indentListItem(editor, Editor.node(editor, liPathRef.current))
    liPathRef.unref()
  }

}

export const outdentMultipleListItems = (editor) => {
  const [startPath, endPath] = Range.edges(editor.selection as Range).map((point) => Editor.above(editor, { at: point.path, match: (node) => node['type'] === 'li' })?.[1]);

  const selectedListItems = Array.from(Editor.nodes(editor, {
    match: (n) => {
      return n['type'] === 'li'
    }
  }))

  const rootListPath = getRootListPath(editor, startPath)

  const isListItemFromRootListSelected = selectedListItems.some(([, listItemPath]) => Path.isChild(listItemPath, rootListPath)
  )
  const lastListHasNestedItem = LIST_TYPES.includes(Editor.next(editor, { at: endPath })?.[0]?.type)


  if (isListItemFromRootListSelected || lastListHasNestedItem) return

  const selectedListItemPathRefs = selectedListItems.map(([, path]) => {
    return Editor.pathRef(editor, path)
  })

  for (const liPathRef of selectedListItemPathRefs) {
    outdentListItem(editor, Editor.node(editor, liPathRef.current))
    liPathRef.unref()
  }
}

export const indentListItemForUpdatedListStructure = (editor, li) => {
  const liPath = li[1]

  const parentListEntry = Editor.parent(editor, liPath)
  const parentLiEntry = Editor.previous(editor, { at: liPath })

  if (liPath.at(-1) == 0 || !parentListEntry || !parentLiEntry) {
    return null
  }
  const [parentList] = parentListEntry

  const [previousLi, previousLiPath] = parentLiEntry

  const previousListEntry = getPreviousList(editor, liPath)
  const nextListEntry = getNextList(editor, liPath)
  const nextListRef = nextListEntry ? Editor.pathRef(editor, nextListEntry[1]) : null
  let moveTo = [...previousLiPath, previousLi.children.length]

  if (previousListEntry) {
    const [node, path] = previousListEntry
    moveTo = [...path, node.children.length]
  }
  if (!previousListEntry) {
    Transforms.wrapNodes(editor, jsx('element', { type: parentList['type'] }), { at: liPath })
  }

  Transforms.moveNodes(editor, { at: liPath, to: moveTo })
  if (nextListRef) {
    const moveListTo = previousListEntry ? Path.next(moveTo) : [...moveTo, 1]
    Transforms.moveNodes(editor, { at: nextListRef.current, to: moveListTo })
    Transforms.unwrapNodes(editor, { at: moveListTo })
    nextListRef.unref()
  }
}

export const indentMultipleListItemsForUpdatedListStructure = (editor) => {
  const [startPath, endPath] = Range.edges(editor.selection as Range).map((point) => Editor.above(editor, { at: point.path, match: (node) => node['type'] === 'li' })?.[1]);

  const selectedListItems = Array.from(Editor.nodes(editor, {
    match: (n, p) => {
      return n['type'] === 'li' && (
        (Path.isAfter(p, startPath) && Path.isBefore(p, endPath)) ||
        Path.equals(p, startPath) ||
        Path.equals(p, endPath)
      )
    },
  }))

  const selectedNodesRefs = selectedListItems.map(([, path]) => {
    return Editor.pathRef(editor, path)
  })

  if (selectedListItems[0][1].at(-1) === 0) return

  for (const liPathRef of selectedNodesRefs) {
    indentListItemForUpdatedListStructure(editor, Editor.node(editor, liPathRef.current))
    liPathRef.unref()
  }

}

export const outdentMultipleListItemsForUpdatedListStructure = (editor) => {
  const [startPath, endPath] = Range.edges(editor.selection as Range).map((point) => Editor.above(editor, { at: point.path, match: (node) => node['type'] === 'li' })?.[1]);

  const selectedListItems = Array.from(Editor.nodes(editor, {
    match: (n, p) => {
      return n['type'] === 'li' && (
        (Path.isAfter(p, startPath) && Path.isBefore(p, endPath)) ||
        Path.equals(p, startPath) ||
        Path.equals(p, endPath)
      )
    },
  }))

  const selectedNodesRefs = selectedListItems.map(([, path]) => {
    return Editor.pathRef(editor, path)
  })

  for (const liPathRef of selectedNodesRefs) {
    outdentListItemForUpdatedListStructure(editor, Editor.node(editor, liPathRef.current))
    liPathRef.unref()
  }

}

export const exitList = (editor) => {

  if (editor.selection) {
    if (editor.rteVersion >= 1) {
      const [listItemEntry] = Editor.nodes(editor, {
        match: (n: ElementWithType) => {
          return n.type === 'li'
        },
        mode: 'lowest'
      })
      if (listItemEntry) {
        const [listItem, listItemPath] = listItemEntry
        // check if text exist
        if (Node.string(listItem) === '') {
          const listItemEntryParent = Node.parent(editor, listItemPath)
          const listItemEntryIndex = listItemPath.at(-1)
          if (listItemEntryParent && listItemEntryIndex === listItemEntryParent?.children?.length - 1) {
            const parentLiEntry = getParentLi(editor, listItemEntry[1])
            if (!parentLiEntry) return false
            outdentListItemForUpdatedListStructure(editor, listItemEntry)
          }
          else {
            const [listEntry] = Editor.nodes(editor, {
              match: (n: any) => {
                return LIST_TYPES.includes(n.type)
              }
            })

            if (listEntry) {
              const listParentPath = listEntry[1]
              const nextPath = Path.next(listParentPath)

              Transforms.insertNodes(editor, normalTextElement, { at: nextPath })
              Transforms.removeNodes(editor, { at: listItemPath })

              try {
                Transforms.select(editor, nextPath)
              } catch (e) {
                Transforms.select(editor, listParentPath)
              }
              return true
            }
          }

        }

        if (Range.isExpanded(editor.selection)) {
          Transforms.collapse(editor)
        }
        let addNewListItemToPath = Path.next(listItemPath)
        const isAtEnd = Editor.isEnd(editor, editor.selection.focus, [...listItemPath, 0])
        const isAtStart = Editor.isStart(editor, editor.selection.focus, [...listItemPath, 0])
        if (isAtStart && !isAtEnd) {
          Transforms.insertNodes(editor, jsx('element', { type: 'li' }), { at: listItemPath })
        }

        else if (isAtEnd && !isAtStart) {
          let newChildren = [{
            type: 'fragment',
            children: [{ text: '' }]
          }]
          const fragmentChild = Array.from(listItem.children).find((child: any) => child.type === 'fragment')
          if (fragmentChild) {
            let newLiChildren = Array.from(listItem.children).filter((child: any) => child.type !== 'fragment')
            if (newLiChildren) {
              Array.from(newLiChildren).forEach((child: any) => {
                newChildren.push(child)
                let childPath = ReactEditor.findPath(editor, child)
                Transforms.removeNodes(editor, { at: childPath })
              })
              let newLiNode = {
                type: 'li',
                children: [...newChildren]
              }
              Transforms.insertNodes(editor, newLiNode, { at: addNewListItemToPath })
              Transforms.select(editor, addNewListItemToPath)
              Transforms.collapse(editor)
            }
          }
          else {
            Transforms.insertNodes(editor, jsx('element', { type: 'li' }), { at: addNewListItemToPath })
            Transforms.select(editor, addNewListItemToPath)
            Transforms.collapse(editor)
          }
        }

        else if (!isAtStart && !isAtEnd) {
          Transforms.splitNodes(editor, { match: (n) => n['type'] === 'li' })
          try {
            Transforms.setNodes(editor, jsx('element', { type: "fragment" }), { match: (n) => n?.['type'] === 'p', at: [...addNewListItemToPath, 0] })
          } catch (error) {
            console.error("could not convert p to fragment", error)
          }
        }
        return true
      }
    }
    else {
      const [listItemObjPath] = Editor.nodes(editor, {
        match: (n: ElementWithType) => {
          return n.type === 'li'
        },
        mode: 'lowest'
      })

      const [table] = Array.from(Editor.nodes(editor, {
        mode: 'lowest',
        match: (n: ElementWithType) => {
          return n.type === 'table'
        }
      }))

      // If table is in list do normal insertBreak

      if (listItemObjPath) {
        const [listItem, listItemPath] = listItemObjPath

        if (table && Path.isAncestor(listItemPath, table[1])) {
          return false
        }

        // check if text exist
        if (Node.string(listItem) === '' && !checkIfListItemHasContent(editor, listItemPath)) {
          const [listParentObjPath] = Editor.nodes(editor, {
            match: (n: any) => {
              return LIST_TYPES.includes(n.type)
            },
          })

          if (listParentObjPath) {
            const listParentPath = listParentObjPath[1]

            const nextPath = listParentPath.slice()
            nextPath[nextPath.length - 1] += 1

            Transforms.insertNodes(editor, normalTextElement, { at: nextPath })
            Transforms.removeNodes(editor, { at: listItemPath })

            try {
              Transforms.select(editor, nextPath)
            } catch (e) {
              Transforms.select(editor, listParentPath)
            }
            return true
          }
        }
        else {
          if (Range.isExpanded(editor.selection)) {
            Transforms.collapse(editor)
          }
          let addNewListItemToPath = Path.next(listItemPath)

          const isAtEnd = Editor.isEnd(editor, editor.selection.focus, listItemPath)
          const isAtStart = Editor.isStart(editor, editor.selection.focus, listItemPath)
          if (isAtStart && !isAtEnd) {
            Transforms.insertNodes(editor, jsx('element', { type: 'li' }), { at: listItemPath })
          }

          else if (isAtEnd && !isAtStart) {
            Transforms.insertNodes(editor, jsx('element', { type: 'li' }), { at: addNewListItemToPath })
            Transforms.select(editor, addNewListItemToPath)
            Transforms.collapse(editor)
          }

          else if (!isAtStart && !isAtEnd) {
            Transforms.splitNodes(editor, { match: (n) => n['type'] === 'li' })
            Transforms.select(editor, addNewListItemToPath)
            Transforms.collapse(editor, { edge: "start" })

          }
          return true
        }
      }
    }
  }
}

export function getParentLi(editor, liPath) {
  const [parentLi] = Editor.nodes(editor, {
    at: liPath,
    mode: 'lowest',
    match: (node, path) => Element.isElement(node) && node['type'] === 'li' && Path.isAncestor(path, liPath)
  })
  return parentLi
}

export function getPreviousList(editor, liPath) {
  return getNextList(editor, Path.previous(liPath))
}

export function getNextList(editor, liPath) {
  const [currentListEntry] = Editor.nodes<Element>(editor, {
    at: liPath,
    match: (node: any, path) =>
      Element.isElement(node) && LIST_TYPES.includes(node.type) && Path.isAncestor(liPath, path)
  })
  return currentListEntry
}
export const checkIfListItemHasContent = (editor, listItemPath) => {
  const [isListItemWithTableOrVoidChildren] = Editor.nodes(editor, {
    at: Editor.range(editor, listItemPath), match: (n: ElementWithType, path) => {
      if (!Path.isAncestor(listItemPath, path)) return false
      return n.type === 'table' || Editor.isVoid(editor, n)
    }
  })
  return isListItemWithTableOrVoidChildren
}
